import React from 'react';

import marker from 'assets/images/marker/inactive.svg';

import * as T from './interfaces';
import * as S from './styles';

export const SuggestionItem = ({
  children,
  ...rest
}: T.ISuggestionItemProps) => (
  <S.ItemSuggestion {...rest}>
    <S.Pointer
      src={marker}
      alt="Simbolo representando um Ponteiro de localização"
    />
    {children}
  </S.ItemSuggestion>
);
